import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Input, Button, Row, Col, Checkbox, Form } from "antd";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { notificationError } from "utils/libHelpers/AntdNotification";
import { viewAccessRightsStore } from "Pages/Project/Views/Stores/AccessRightsStore";
import { Loader } from "Components/General/Loader";

export interface ViewsFormProps extends WithTranslation, ModalComponentProps {
  onEdit?: (obj: Pick<API_View, "definitionXml" | "id">) => Promise<void>;
  onCreate?: (obj: API_View, params: { [key: string]: boolean }) => Promise<void>;
  viewId?: number;
  project?: Pick<API_Project, "id" | "name">;
}

interface ViewsFormState {
  loading: boolean;
  initialLoading: boolean;
  definitionXml: string;
  allUsers: boolean;
}
// onValuesChange: (props: ViewsFormProps, values) => {
//   if (Object.keys(values).length > 0) {
//     props.setConfirmOnCancel(true);
//   } else {
//     props.setConfirmOnCancel(false);
//   }
// }

export const ViewsForm = withTranslation(I18N_NS.ADMIN)(
  class extends React.Component<ViewsFormProps, ViewsFormState> {
    static defaultProps: Pick<ViewsFormProps, "viewId"> = {
      viewId: null,
    };

    readonly state: ViewsFormState = { loading: false, initialLoading: true, definitionXml: "", allUsers: false };

    componentDidMount() {
      if (this.props.viewId) {
        (async () => {
          const {
            t,
            viewId,
            project: { id },
          } = this.props;
          viewAccessRightsStore.setViewId(viewId);
          await viewAccessRightsStore.fetch();
          try {
            const response: Pick<API_View, "definitionXml"> = await API.getData(API_URL.VIEWS.getView(id, viewId));
            this.setState({ definitionXml: response.definitionXml, initialLoading: false });
          } catch (error) {
            notificationError(t("Error"), t("Error"));
            throw error;
          }
        })();
      } else {
        this.setState({ initialLoading: false });
      }
    }

    handleSubmit = async (values) => {
      const { viewId } = this.props;
      try {
        this.setState({ loading: true });
        if (!viewId) {
          await this.props.onCreate(values, { allUsers: this.state.allUsers });
        } else {
          await this.props.onEdit({ id: viewId, definitionXml: values.definitionXml });
        }
        this.props.setConfirmOnCancel(false);
        this.props.hideModal();
      } catch (error) {
        throw error;
      } finally {
        this.setState({ loading: false });
      }
    };

    render() {
      const { t, viewId } = this.props;
      const { loading, initialLoading, definitionXml } = this.state;
      const initialValues = {
        definitionXml: definitionXml || "",
      };
      if (initialLoading) {
        return <Loader />;
      }

      return (
        <Form
          onFinish={this.handleSubmit}
          initialValues={initialValues}
          onValuesChange={(changedValues: ViewsFormProps, values) => {
            if (Object.keys(values).length > 0) {
              this.props.setConfirmOnCancel(true);
            } else {
              this.props.setConfirmOnCancel(false);
            }
          }}
        >
          <Row justify="space-between" gutter={16}>
            <Col xs={24}>
              <Form.Item label={t("XML definition")} name="definitionXml" colon={true}>
                <Input.TextArea rows={10} style={{ border: "1px solid #e4e4e4", padding: "10px" }} />
              </Form.Item>
            </Col>
            {!viewId && (
              <Col xs={24}>
                <Form.Item>
                  <Checkbox onChange={(e) => this.setState({ allUsers: e.target.checked })}>
                    {t('Grant group "All users" reading access')}
                  </Checkbox>
                </Form.Item>
              </Col>
            )}
          </Row>
          <ButtonsRow justify="space-between">
            <Button onClick={this.props.hideModal}>{t("Abort")}</Button>
            <Button type="primary" loading={loading} htmlType="submit">
              {t("Save")}
            </Button>
          </ButtonsRow>
        </Form>
      );
    }
  }
);
